/**
 * Iniciales para el avatar del usuario.
 * - Sin palabras: ''.
 * - Una palabra: sus 2 primeras letras en mayúscula.
 * - Dos o más: inicial de la primera y de la última palabra.
 */
export function getUserInitials(name: string | null | undefined): string {
  const parts = (name ?? '')
    .trim()
    .split(/\s+/)
    .filter((p) => p.length > 0);
  if (parts.length === 0) return '';
  if (parts.length === 1) return parts[0].substring(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}
